import React, { FC } from 'react';
import moment from 'moment';

import { IReportViolations } from '../../../models/types';

import Table from '../../../components_/Table';
import TableColText from '../../../components_/Table/TableColText';

interface IProps {
  list: IReportViolations[];
}

const List: FC<IProps> = ({ list }) => {
  const rows = list.map(item => ({
    items: {
      time: (
        <TableColText>{item.time && moment(item.time).format('DD.MM.YYYY HH:mm')}</TableColText>
      ),
      violation: <TableColText>{item.violation}</TableColText>,
      employeeName: <TableColText>{item.employeeName}</TableColText>,
      areaName: <TableColText>{item.areaName}</TableColText>,
      mapName: <TableColText>{item.mapName}</TableColText>,
      officeName: <TableColText>{item.officeName}</TableColText>
      // cause: <TableColText>{item.cause}</TableColText>,
    }
  }));

  const cols = [
    {
      title: 'Дата/Время',
      field: 'time'
    },
    {
      title: 'Тип нарушения',
      field: 'violation'
    },
    {
      title: 'ФИО сотрудника',
      field: 'employeeName'
    },
    {
      title: 'Зона',
      field: 'areaName'
    },
    {
      title: 'План',
      field: 'mapName'
    },
    {
      title: 'Место',
      field: 'officeName'
    }
    // {
    //   title: 'Причина нарушения',
    //   field: 'cause'
    // },
  ];

  return <Table cols={cols} rows={rows} />;
};

export default List;
